import { render } from "./QuestionTwo.vue?vue&type=template&id=35d3ba67&scoped=true"
import script from "./QuestionTwo.vue?vue&type=script&lang=js"
export * from "./QuestionTwo.vue?vue&type=script&lang=js"

import "./QuestionTwo.vue?vue&type=style&index=0&id=35d3ba67&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d3ba67"]])

export default __exports__